import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { fetchService } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsCampaignUtils";

import type { QueryParams } from "../../../types";
import type { ITopPaidData, ITopPaidRawData, ITopPaidResponse } from "../types";

const TOP_PAID_LANDING_PAGES_QUERY_KEY = "TOP_PAID_LANDING_PAGES_DATA";

interface ITopPaidParams extends QueryParams {
    webSource: string;
}

function transformData(data: ITopPaidRawData[]): ITopPaidData[] {
    return data.map(({ Url, Clicks, ClicksShare, MoMChange, Spend, TopKeyword, TotalKeywords }: ITopPaidRawData) => ({
        url: Url,
        clicks: {
            clicks: Clicks,
            clicksShare: ClicksShare,
        },
        moMChange: MoMChange,
        spend: Spend,
        keywords: {
            topKeyword: TopKeyword,
            totalKeywords: TotalKeywords,
            url: Url,
        },
    }));
}

async function fetchTopPaidData(params: ITopPaidParams) {
    try {
        const response = await fetchService.get<ITopPaidResponse>(`/api/searchoverview/keywords/landing-pages`, {
            ...params,
        });
        return transformData(response);
    } catch (error) {
        Sentry.error(`Error fetching top-paid-landing-pages Data`, error);
    }
}

export function useTopPaidData(params: ITopPaidParams, enabled = true): UseQueryResult<ITopPaidData[]> {
    return useQuery({
        queryKey: [TOP_PAID_LANDING_PAGES_QUERY_KEY, params],
        queryFn: () => fetchTopPaidData(params),
        enabled,
        staleTime: Infinity,
    });
}
